module.exports = eval("try{require('inspector')}catch(e){}");